module.exports = __webpack_public_path__ + "static/img/advert_2_3.e153799.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CopierSelfprinting/advert_2_3.png
// module id = gLZ0
// module chunks = 10